import React from 'react';
import Header from '@modules/common/components/Header';
import { ModalContent } from '@modules/common/components/BaseModal/ModalContent';
import { ModalActions } from '@modules/common/components/BaseModal/ModalActions';
import useCopyToClipboard from '@src/hooks/CopyToClipboard';
import { styled } from '@modules/common/components/ThemeProvider/utils';
import SecondaryButton from '@modules/common/components/buttons/SecondaryButton';
import { ModalDescription } from '@modules/common/components/BaseModal/ModalDescription';
import WarningMessage from '@modules/common/components/banners/WarningMessage';
import Input from '@modules/common/components/Input';
import BaseForm from '@modules/common/components/BaseForm';
import { ModalHeader } from '@modules/common/components/BaseModal/ModalHeader';

import { OAuthClientDescriptor } from '../../../components/types/oauth-client';

const SECRET_HEADER = 'New OAuth client created';
const SECRET_COPY_WARNING =
  'Make sure to copy your new personal OAuth client secret now. You will not be able to see it again!';
const YOUR_SECRET_LABEL = 'Client secret:';

type Props = {
  handleClose: () => void;
  client: OAuthClientDescriptor;
};

const OAuthClientSecretMessage = ({ handleClose, client }: Props) => {
  const { copyAction: copyClientId } = useCopyToClipboard(client.clientId);
  const { copyAction: copySecret } = useCopyToClipboard(client.parameters.secret);

  return (
    <>
      <ModalHeader>
        <Header content={SECRET_HEADER} icon="info circle" />
      </ModalHeader>
      <ModalContent>
        <StyledModalDescription>
          <Header size="huge">{client.name}</Header>
        </StyledModalDescription>
        <BaseForm>
          <StyledInput
            fluid
            readOnly
            labelPosition="left"
            label="Client ID:"
            value={client.clientId}
            action={copyClientId}
            size="huge"
            autoFocus
          />
          <StyledInput
            fluid
            readOnly
            labelPosition="left"
            label={YOUR_SECRET_LABEL}
            value={client.parameters.secret}
            action={copySecret}
            size="huge"
            autoFocus
          />
        </BaseForm>
        <WarningMessage content={SECRET_COPY_WARNING} warning icon="warning" size="big" />
      </ModalContent>
      <ModalActions>
        <SecondaryButton icon="remove" onClick={handleClose} content="Close" />
      </ModalActions>
    </>
  );
};

export default OAuthClientSecretMessage;

const StyledInput = styled(Input)`
  margin-bottom: 1rem;

  .label {
    min-width: 170px;
  }
`;

const StyledModalDescription = styled(ModalDescription)`
  text-align: center;
  margin-bottom: 1rem;
`;
